import React, { useCallback } from 'react';
import { UN_EDITABLE_TASK_STATUS } from 'utils/constants/task';
import BaseDetails from './Layouts/baseSecurityDetails';
import Operational from './operational';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ManagerAndAbove, userHasRole } from 'utils/helper/roles';
import { getUserRoles } from 'reducers/users';
import { TASK_CLEANING_DEFAULT } from 'utils/constants/taskCleaner';

const SecurityDetails = ({
  id,
  selected,
  // setMessage,
  // resetMsg,
  onChange,
  ...props
}) => {
  const userRoles = useSelector(state => getUserRoles(state));

  const Operation = useCallback(
    props => (
      <Operational
        {...props}
        onChange={onChange}
        defaultValues={TASK_CLEANING_DEFAULT}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  const loading = useSelector(state => state.ui.loading);

  const checkIfEditable = ({ data }) => {
    if (!data.generalInfo.status) return false;
    const statusEditable = !UN_EDITABLE_TASK_STATUS.some(item =>
      data.generalInfo.status.idValue.includes(item),
    );
    return statusEditable
      ? !data.others.isTemplate.value && !selected.isDummyTask
      : statusEditable;
  };

  return (
    <BaseDetails
      id={selected && selected.isDummyTask ? selected.templateId : id}
      selected={selected}
      {...props}
      checkCanBeEdited={checkIfEditable}
      operationComponent={Operation}
      loading={loading}
      downloadable={userHasRole({
        userRoles: userRoles,
        requiredRoles: ManagerAndAbove,
      })}
    />
  );
};
SecurityDetails.propTypes = {
  id: PropTypes.string,
  selected: PropTypes.object,
  setMessage: PropTypes.func,
  resetMsg: PropTypes.func,
  onChange: PropTypes.func,
  downloadable: PropTypes.bool,
};
export default SecurityDetails;
